import { useEffect } from 'react'
import { useBlocker, useLocation, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { type IChatbotFullData } from 'entities/Chatbot'
import {
  ChatbotDialog,
  ChatbotLayout,
  ChatbotLayoutContent,
  ChatbotLayoutWrapper,
  DialogLayout,
  RootLayout,
} from 'pages/chatbot/ui'
import {
  ChatbotDialogProvider,
  ChatbotProvider,
  useChatbotContext,
  useChatbotDialogContext,
} from 'pages/chatbot/context'
import { ChatbotBody } from 'pages/chatbot/ui/ChatbotEdit'
import { ChatbotEditHead } from './ChatbotEditHead'

const ChatbotEditContent = observer(({ initialData }: { initialData: IChatbotFullData }) => {
  const { start } = useChatbotDialogContext()
  const {
    loaded,
    enrollment,
    isDraggingCondition,
    initResources,
    loadChatbot,
    confirmUpdateChatbot,
    checkChanges,
    model: { firstMessage },
  } = useChatbotContext()

  const { state } = useLocation()
  const { agentId } = useParams()
  const blocker = useBlocker(() => {
    const hasChanges = checkChanges()

    return hasChanges
  })

  useEffect(() => {
    if (blocker.state === 'blocked') confirmUpdateChatbot(blocker)
  }, [blocker.state])

  useEffect(() => {
    initResources()
    enrollment.initFilters()

    if (!agentId) return

    loadChatbot(+agentId, undefined, initialData).then((loaded) => {
      if (loaded && state?.test) start(firstMessage.isAutoConvType)
    })
  }, [])

  return (
    <>
      {!loaded ? (
        <SpinnerLoader ariaLabel={'ChatbotEditContent'} />
      ) : (
        <ChatbotLayout>
          <ChatbotLayoutWrapper>
            <ChatbotLayoutContent isDraggingCondition={isDraggingCondition}>
              <ChatbotBody />
            </ChatbotLayoutContent>
          </ChatbotLayoutWrapper>
        </ChatbotLayout>
      )}
    </>
  )
})

const ChatbotEditDialog = observer(() => {
  const { loaded } = useChatbotContext()
  const { started } = useChatbotDialogContext()

  if (!loaded) return null

  return (
    <DialogLayout active={started}>
      <ChatbotDialog />
    </DialogLayout>
  )
})

/**
 * @deprecated
 */
export const ChatbotEditOldPage = ({ initialData }: { initialData: IChatbotFullData }) => (
  <ChatbotProvider>
    <ChatbotDialogProvider>
      <ChatbotEditHead />
      <RootLayout>
        <ChatbotEditContent initialData={initialData} />
        <ChatbotEditDialog />
      </RootLayout>
    </ChatbotDialogProvider>
  </ChatbotProvider>
)
